import { configureStore } from '@reduxjs/toolkit';
import SlotReducer from './slot';
import CommonReducer from './common';
import productReducer from './products';

export default configureStore({
  reducer: {
    slot: SlotReducer,
    common: CommonReducer,
    product: productReducer,
  },
});
